import uuid from './uuid';

type IKeyStore = 'fozito-admin-web-app-tokenKey' | 'fozito-admin-web-app-refreshToken' | 'fozito-admin-web-app-username' | 'fozito-admin-web-app-shop_id' | 'fozito-admin-web-app-device_id' | 'fozito-admin-web-app-station_number' | 'fozito-admin-web-app-device_type' | 'admin-web-app-role' | 'fozito-admin-web-app-manager_id' | 'fozito-admin-web-app-mode-view-media';

const session = {
  set: (keyValue: IKeyStore, value: string) => {
    return sessionStorage.setItem(keyValue, value);
  },

  get: (keyValue: IKeyStore) => {
    return sessionStorage.getItem(keyValue);
  },
};

const local = {
  set: (keyValue: IKeyStore, value: string) => {
    return localStorage.setItem(keyValue, value);
  },

  get: (keyValue: IKeyStore) => {
    return localStorage.getItem(keyValue);
  },
};

const genGetSetKeyLocal = (key: IKeyStore) => ({
  get: () => local.get(key) ?? '',
  set: (value: string) => local.set(key, value),
});

const genGetSetKeySession = (key: IKeyStore) => ({
  get: () => session.get(key) ?? '',
  set: (value: string) => session.set(key, value),
});

export const getDeviceId = () => {
  const device_id = storage.device_id.get();
  if (device_id) return device_id;
  const new_device_id = uuid();
  storage.device_id.set(new_device_id);
  return new_device_id;
};

const storage = {
  get: session.get,
  set: session.set,
  genGetSetKeyLocal,
  genGetSetKeySession,
  token: genGetSetKeyLocal('fozito-admin-web-app-tokenKey'),
  refreshToken: genGetSetKeyLocal('fozito-admin-web-app-refreshToken'),
  username: genGetSetKeyLocal('fozito-admin-web-app-username'),
  device_id: genGetSetKeyLocal('fozito-admin-web-app-device_id'),
  station_number: genGetSetKeyLocal('fozito-admin-web-app-station_number'),
  shop_id: genGetSetKeyLocal('fozito-admin-web-app-shop_id'),
  device_type: genGetSetKeyLocal('fozito-admin-web-app-device_type'),
  manager_id: genGetSetKeyLocal('fozito-admin-web-app-manager_id'),
  role: genGetSetKeyLocal('admin-web-app-role'),
  modeViewMedia: genGetSetKeyLocal('fozito-admin-web-app-mode-view-media'),
};

export default storage;
